import React from 'react';
import styled from 'styled-components';
import { updateClient } from '../../../api/clients';
import { toaster } from '../../../helpers/toaster';

const AttachmentOnlyCheckbox = (props) => { 
  const onCheckboxChange = (e) => {
    updateClient(props.data?.id, {only_attachment: !props.value}).then(res => {

      // for clients list page
      // setRefreshData(true)

      toaster("Client updated successfully", "success")
      // setClientLoading(false);
      // setOpenClientModal(false)
      return res.data
    }).catch(error => {
      toaster("Failed to update client", "error")
      // setClientLoading(false);
      // setOpenClientModal(false)
    });
    props.setValue(!props.value)
    // updateBool(props.data?.id, props.source, (!props.value)).then(res => {
      
    //   toaster(`Updated ${props.source} on study ${props.data.org_study_id}`,"success");

    //   props.setValue(!props.value);
    // });
  };

  return (
    <CheckboxWrapper>
      <input type='checkbox' checked={props.value} onChange={(e) => onCheckboxChange(e)} />
      {
        props.source === 'published'
          ? props.value ? <i className="fas fa-eye" style={{marginLeft: "5px"}}></i> : <i className="fas fa-eye-slash" style={{marginLeft: "5px"}}></i>
          : props.source === 'featured'
            ? props.value ? <i className="fas fa-star" style={{marginLeft: "5px"}}></i> : ""
            : ""
      }
    </CheckboxWrapper>
  );
};

export default AttachmentOnlyCheckbox;

const CheckboxWrapper = styled.div`
  display: flex;
  padding-top: 5px;
`
